<template>
  <div class="private-cloud-resource-detail-content">
    <SetGateway ref="SetGateway" v-on:setComplete="init"></SetGateway>
    <Card shadow style="border-radius: unset">
      <a style="margin-right: 24px" v-on:click="$router.push({ name: 'route' })">
        <Icon type="md-arrow-round-back" size="18" />
      </a>
      <h3 style="color: #171d25; display: inline-block;">{{ info.name }}</h3>
      <div style="float: right">
        <Button v-if="info.external_gateway_info" size="small" type="error" @click="clearGateway" style="margin-right: 10px">清除网关</Button>
        <Button v-else size="small" type="primary" @click="$refs.SetGateway.openModal(info.id, info.name)" style="margin-right: 10px">设置网关</Button>
      </div>
    </Card>
    <div class="main">
      <div>
        <Row>
          <Col :xs="24" :sm="24" :md="24" :lg="24">
            <div>
              <Alert v-if="infoError" type="warning" show-icon>获取路由详情数据失败</Alert>
              <div class="info-property" v-else style="margin-right: unset">
                <div class="resource-content-title">
                  <h4>路由信息</h4>
                </div>
                <dl>
                  <dt>ID</dt><dd>{{ info.id }}</dd>
                </dl>
                <dl>
                  <dt>网络名称</dt><dd>{{ info.name }}</dd>
                </dl>
                <dl>
                  <dt>状态</dt>
                  <dd v-if="info.status === 'ACTIVE'">运行中</dd>
                  <dd v-else-if="info.status === 'DOWN'">不可用</dd>
                  <dd v-else-if="info.status === 'BUILD'">构建中</dd>
                  <dd v-else-if="info.status === 'ERROR'">错误</dd>
                  <dd v-else>{{ info.status }}</dd>
                </dl>
                <dl>
                  <dt>管理状态</dt>
                  <dd v-if="info.admin_state_up"><span>是</span></dd>
                  <dd v-else><span>否</span></dd>
                </dl>
                <dl>
                  <dt>可用区域</dt>
                  <dd>
                    <div v-for="(item, index) in info.availability_zones" :key="'availability_zones_' + index">
                      <p>{{ item }}</p>
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt>外部网关</dt>
                  <dd v-if="info.external_gateway_info">
                    <!--<p><b>网络名称：</b>{{ info.external_gateway_name }}</p>-->
                    <p>
                      <b>网络：</b>
                      <a v-on:click="$router.push({ name: 'network_detail', params: { id: info.external_gateway_info.network_id } })">{{ resourceNetworkIdTransName(info.external_gateway_info.network_id) }}</a>
                    </p>
                    <p>
                      <b>激活SNAT：</b>
                      <span v-if="info.external_gateway_info.enable_snat">是</span>
                      <span v-else>否</span>
                    </p>
                    <div>
                      <b>固定IP：</b>
                      <div style="padding-left: 30px" v-for="(item, index) in info.external_gateway_info.external_fixed_ips" :key="'external_fixed_ips_' + index">
                        <Alert style="font-size: 13px; line-height: 20px; background-color: #fff; border: 1px dashed rgb(230, 230, 230)">
                          <Row><span>子网ID：</span>{{ item.subnet_id }}</Row>
                          <Row><span>IP地址：</span>{{ item.ip_address }}</Row>
                        </Alert>
                      </div>
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt>创建时间</dt><dd v-if="info.created_at">{{ moment(info.created_at).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                </dl>
                <dl>
                  <dt>更新时间</dt><dd v-if="info.updated_at">{{ moment(info.updated_at).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                </dl>
              </div>
              <div class="info-property" style="margin-right: unset;">
                <Row>
                  <RouteInterfaceList ref="RouteInterfaceList" :router_id="$route.params.id"></RouteInterfaceList>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import { detailPrivateCloudRouter } from '@/api/private-cloud/router'
import { resourceIdTransName } from '@/view/private-cloud/cacheData'
import RouteInterfaceList from './components/route-interface-list'
import SetGateway from './components/set-gateway'
import moment from 'moment'

export default {
  name: 'route-detail',
  components: {
    RouteInterfaceList,
    SetGateway
  },
  data () {
    return {
      info: {},
      infoError: false,
      moment: moment
    }
  },
  watch: {
    '$route' () {
      if (this.$route.params.id) {
        this.init()
      }
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.getInfo()
    },
    getInfo () {
      detailPrivateCloudRouter(this.$route.params.id).then(res => {
        this.infoError = false
        this.info = res.data.router
      }).catch(res => {
        this.infoError = true
      })
    },
    clearGateway () {
      this.$Modal.confirm({
        title: '清除网关',
        content: '确定要清除网关吗?',
        onOk: () => {
          this.$refs.SetGateway.clearGateway(this.info.id)
        }
      })
    },
    resourceNetworkIdTransName (id) {
      return resourceIdTransName('networks', id)
    }
  }
}
</script>

<style lang="less">
  @import '../base.less';
</style>
